module.exports = __webpack_public_path__ + "static/media/VestasSans-Standard.e1d8f590.svg";